export default __webpack_public_path__ + "navigation-examples-route-alerts-thumbnail-480-a574c44a9f1bbe8eb83a45aa75407148.webp";